module.exports = __webpack_public_path__ + "static/media/bannerObject1.7b4f73bf.png";